export default "__VITE_ASSET__Dd01Ecf___"